
















































import Vue from "vue";

export default Vue.extend({
  name: "RenderSVG",
  methods: {
      toStyle(c: any) {
          return 'fill:hsl('+c.h+','+c.s+'%,'+c.l+'%)';
      }
  },
  data: () => ({
      rects: [
          {
              x: 447, y: 487, width: 27, height: 731,
              color: { h: 342, s: 80, l: 44 },
          },
          {
              x: 547, y: 487, width: 27, height: 731,
              color: { h: 222, s: 80, l: 44 },
          },
          {
              x: 747, y: 487, width: 27, height: 731,
              color: { h: 102, s: 80, l: 44 },
          },
          {
              x: 247, y: 487, width: 27, height: 731,
              color: { h: 222, s: 80, l: 55 },
          },
          {
              x: 247, y: 487, width: 27, height: 731,
              color: { h: 102, s: 80, l: 66 },
          },
      ],
  }),
});
